export const POSTHOG_EVENTS = {
  cancelSwapOrderConfirmClicked: 'cancel_swap_order_confirm_clicked',
  swapOrderTabSwitched: 'swap_order_tab_switched',
  cancelOrderConfirmClicked: 'cancel_order_confirm_clicked',
  cancelOrderClicked: 'cancel_order_clicked',
  placeTradingOrder: 'place_trading_order',
  orderTabSwitched: 'order_tab_switched',
  historyTabClicked: 'history_tab_clicked',
  placeDecreaseTradingOrder: 'place_decrease_trading_order',
  closePositionMenuToggle: 'close_position_menu_toggle',
  closePositionMarketClose: 'close_position_market_close',
  closePositionSetTpSl: 'close_position_set_tp_sl',
  slFeatureToggle: 'sl_feature_toggle',
  tpFeatureToggle: 'tp_feature_toggle',
  tpSlToggle: 'tp_sl_toggle',

  // common events
  back: 'back', // {current , to}
  close: 'close', // {current , target}
  copyWalletAddress: 'copy_wallet_address', //{in}
  learnMore: 'learn_more', // {key, details, href}
  viewMore: 'view_more', // {key, details, href}
  mediaSection: 'media_section', //{media}
  toggle: 'toggle', //{toggleFunc, status}
  connectWallet: 'connect_wallet', //{walletName, walletAddress}
  disconnectWallet: 'disconnect_wallet',

  // boarding campaign
  boardingCampaignEntryClick: 'boarding_campaign_entry_click',
  campaignClickViewMore: 'campaign_click_view_more',
  campaignTaskClick: 'campaign_task_click', // {href, task}
  rewardEligibleCheck: 'reward_eligible_check',
  campaignClickLearnHow: 'campaign_click_learn_how', //{in}
  goIntract: 'go_intract',
  exploreGalaxy: 'explore_galaxy',
  productDocumentation: 'product_documentation',

  // open market trade
  openMarketTradeFlowTracker: 'open_market_trade_flow_tracker', // {tradeKey, randomHexValue, matchedPositionId, positionListShowedAt}

  // posthog error
  websocketEventError: 'websocket_event_error', // {event, error, rootCause}
};

export const DISABLE_EVENT_LIST = [''];

export const POSTHOG_PROJECT_TOKEN = '';
